import React from "react";

const ROWS = [
  ["Ime", (g) => g.first_name],
  ["Prezime", (g) => g.last_name],
  ["Email", (g) => g.email],
  ["Telefon", (g) => g.phone],
  ["Adresa", (g) => g.address],
  ["Poštanski broj", (g) => g.postal_code],
  ["Grad", (g) => g.city],
  ["Država", (g) => g.country],
  ["OIB", (g) => g.oib],
  ["Tvrtka", (g) => (g.is_company ? [g.company_name, g.company_oib && `OIB ${g.company_oib}`].filter(Boolean).join(" · ") : "")],
  ["Ugosti opet", (g) => (g.would_host_again === true ? "Da" : g.would_host_again === false ? "Ne" : "")],
  ["Dojam", (g) => g.impression],
  ["Napomena", (g) => g.notes],
  ["Boravaka", (g) => String(g._stats?.total_stays ?? 0)],
  ["Zadnji boravak", (g) => g._stats?.last_stay || g.last_stay],
  ["Kreiran", (g) => (g.created_at ? new Date(g.created_at).toLocaleDateString("hr-HR") : "")],
];

const norm = (v) => String(v ?? "").trim().toLowerCase();

// Side-by-side comparison of guests before merging: one column per guest, differing rows highlighted.
export function GuestMergeCompare({ guests, primary, setPrimary }) {
  return (
    <div className="overflow-x-auto rounded-lg border border-border" data-testid="guests-merge-compare">
      <table className="w-full border-collapse text-xs">
        <thead>
          <tr className="bg-muted/40">
            <th className="sticky left-0 z-10 w-28 bg-muted/60 px-3 py-2 text-left font-semibold text-muted-foreground">Polje</th>
            {guests.map((g, i) => (
              <th key={g.id} className={`min-w-[190px] px-3 py-2 text-left align-top ${primary === g.id ? "bg-primary/10" : ""}`}>
                <label className="flex cursor-pointer items-center gap-2" data-testid={`merge-option-${g.id}`}>
                  <input type="radio" name="primary" checked={primary === g.id} onChange={() => setPrimary(g.id)} className="h-4 w-4" style={{ accentColor: "hsl(var(--primary))" }} />
                  <span className="text-sm font-semibold text-foreground">Gost {i + 1}</span>
                  {primary === g.id && <span className="rw-badge bg-primary/15 text-primary">Glavni</span>}
                </label>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ROWS.map(([label, get]) => {
            const vals = guests.map((g) => get(g) || "");
            const filled = vals.filter((v) => norm(v));
            const differs = new Set(filled.map(norm)).size > 1;
            return (
              <tr key={label} className={`border-t border-border ${differs ? "bg-amber-50 dark:bg-amber-500/10" : ""}`}>
                <td className="sticky left-0 z-10 bg-card px-3 py-1.5 font-medium text-muted-foreground">{label}</td>
                {vals.map((v, i) => (
                  <td key={guests[i].id} className={`whitespace-pre-wrap break-words px-3 py-1.5 text-foreground ${primary === guests[i].id ? "bg-primary/5" : ""}`}>
                    {v || <span className="text-muted-foreground/60">—</span>}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
